import React from 'react';
import { useStyletron } from 'baseui';
import { DataList, Loader } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import useUserDeposits from './useUserDeposits';
import { columnConfigs } from './listConfig';
import DateRangeFilter from './DateRangeFilter';
import TextInputFilter from './TextInputFilter';

const UserDeposits: React.FC<{}> = () => {
	const { getUserDepositsData, handleFilterSubmit, forceUpdate, showLoader } = useUserDeposits();

	const [css] = useStyletron();

	return (
		<>
			{showLoader && <Loader />}
			<div>
				<div
					className={css({
						height: '60px',
						display: 'flex',
						alignItems: 'center',
						backgroundColor: 'white',
						paddingLeft: '10px',
						borderTop: '1px solid rgb(242, 242, 242)',
						gap: '100px'
					})}>
					<DateRangeFilter onSubmit={handleFilterSubmit} />
					<TextInputFilter onSubmit={handleFilterSubmit} />
				</div>
				<DataList
					fetchData={getUserDepositsData}
					columnConfigs={columnConfigs}
					hideActions
					rowHeight={50}
					entity={LIST_ENTITY_NAMES.USER_DEPOSITS}
					globalForceUpdate={forceUpdate}
					height='calc(100vh - 220px)'
				/>
			</div>
		</>
	);
};

export default UserDeposits;
